"use client";
import {
  useTooltipStore
} from "../__chunks/BZZ52UJN.js";
import {
  TooltipContextProvider
} from "../__chunks/L3J7PHFC.js";
import "../__chunks/GVVKDT6A.js";
import "../__chunks/7Z7JH52O.js";
import "../__chunks/RUY5BUJG.js";
import "../__chunks/Y2U4BRIM.js";
import "../__chunks/T22PY7TE.js";
import "../__chunks/Y67KZUMI.js";
import "../__chunks/T2AZQXQU.js";
import "../__chunks/ABN76PSX.js";
import "../__chunks/RTNCFSKZ.js";
import "../__chunks/VOQWLFSQ.js";
import "../__chunks/5GGHRIN3.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip-provider.tsx
import { jsx } from "react/jsx-runtime";
function TooltipProvider(props = {}) {
  const store = useTooltipStore(props);
  return /* @__PURE__ */ jsx(TooltipContextProvider, { value: store, children: props.children });
}
export {
  TooltipProvider
};
